import angular from 'angular';

// converts snake/kebab case to words
module.exports = angular.module('common.filters.wordcase', [])
.filter('wordcase', function() {
  return function(input) {
   if (!input) return '';
   return input.replace(/[-_\s]+/g, ' ');
  };
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/filters/wordcase.js
 **/